const BaseURL = "https://stagflexapi.appiness.co.in/api/admin";
const SocketURL = "ws://stagflexapi.appiness.co.in/ws";
const CommonUrl = "https://stagflexapi.appiness.co.in/api/common";

export const API = {
  //
  LOGIN: `${BaseURL}/login/`,
  CHANGE_PASSWORD: `${BaseURL}/change-password/`,
  FORGOT_PASSWORD: `${BaseURL}/forgot-password/`,
  MEDIA_UPLOAD: `${BaseURL}/media-upload/`,
  VIEW_PROFILE: `${BaseURL}/view-profile/`,
  EDIT_PROFILE: `${BaseURL}/edit-profile/`,
  GET_NOTIFICATION: `${BaseURL}/notification`,
  NOTIFICATION_COUNT: `${SocketURL}/admin-notification`,

  GET_CANDIDATES: `${BaseURL}/all-candidates-list`,
  GET_CANDIDATES_FILTERS: `${BaseURL}/all-candidates-filters/`,
  GET_CANDIDATE_DETAILS: `${BaseURL}/candidate-detail`,
  GET_CANDIDATES_CITY_LIST: `${BaseURL}/all-candidates-city-list`,

  GET_CANDIDATE_TIMELINE: `${BaseURL}/candidate-timeline`,
  DOWNLOAD_CANDIDATE_TIMELINE: `${BaseURL}/candidate-timeline-download`,
  DOWNLOAD_FLEXIBEES_RESUME: `${BaseURL}/candidate-resume-download`,
  CANDIDATE_JOURNEY: `${BaseURL}/candidate-journey`,
  CANDIDATE_JOURNEY_FEEDBACK: `${BaseURL}/candidate-feedback-list`,
  CANDIDATE_DETAILS_UPDATE: `${BaseURL}/candidate-details-update/`,

  JOB_LISTING: `${BaseURL}/jobs/list`,
  JOB_STATUS: `${BaseURL}/job/status`,
  EDIT_JOB_DETIALS: `${BaseURL}/job`,
  Job_INTERVIEW_SCHEDULE: `${BaseURL}/job/schedule`,
  CANDIDATE_JOB_STATUS: `${BaseURL}/job/candidate-job-status/list`,
  FEEDBACK_STATUS: `${BaseURL}/job/update-feedback`,
  ASSET_UPLOAD: `${CommonUrl}/asset-upload`,
  NOTIFY_NEXT_CANDIDATES: `${BaseURL}/notify-candidates`,
  MARKETPLACE_UPDATE: `${BaseURL}/candidate-detail-mp-update`,
  REJECT_SELECTED_CANDIDATE: `${BaseURL}/job/reject-selected-candidate`,
  JOB_CLOSURE: `${BaseURL}/job/close`,

  //MP LAUNCHES
  MP_LAUNCH_LIST: `${BaseURL}/job/launch/list`,
  MP_LAUNCH_LIST_UPDATE: `${BaseURL}/job/launch/update/`,
  MP_LAUNCH_LIST_EXPORT: `${BaseURL}/job/launch/download`,

  //Notes
  MP_LAUNCH_NOTE_LIST: `${BaseURL}/job/launch/notes-list`,
  MP_LAUNCH_CREATE_NOTE: `${BaseURL}/job/launch/create-notes`,

  // candidate feedback
  CANDIADTE_FEEDBACK: `${BaseURL}/candidate-launch-feedback/create`,
  MP_LAUNCH_DETAILS: `${BaseURL}/job_launch/details/`,
  UPDATE_CANDIDATE_FEEDBACK: `${BaseURL}/candidate-launch-feedback`,

  CLIENT_FEEDBACK: `${BaseURL}/client-launch-feedback/create`,
  UPDATE_CLIENT_FEEDBACK: `${BaseURL}/client-launch-feedback`,

  MP_OFFERS_LIST:`${BaseURL}/offer/list`,
  MP_OFFER_CREATE:`${BaseURL}/add-offer-launch`,
  MP_OFFER_UPDATE:`${BaseURL}/edit-offer-launch`,
  JOB_DETAILS:`${BaseURL}/job/details/`,
  COMPANY_EXCLUDE: `${BaseURL}/company/exclude-flag/`,
  ADD_CANDIDATES:  `${BaseURL}/job/add-candidate/`,
  MULTIPLE_CANDIDATE_NOTES:`${BaseURL}/candidate-notes/`,
  CANDIDATE_NOTES: `${BaseURL}/candidate-notes/create/`,
  EDIT_CANDIDATE_NOTES:`${BaseURL}/candidate-notes/`
};
